import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class StickersAPI {
  static async index(businessTypeIds?: any): Promise<any> {
    const types = Array.isArray(businessTypeIds) ? businessTypeIds.join(',') : businessTypeIds
    const queryString = FormsService.prepareQueryString({ types }, true)
    return (await $http.get(`/stickers?${queryString}`)).data
  }

  static async create(body: any) {
    return (await $http.post('/stickers/add', body)).data
  }

  static async update(body: any) {
    return (await $http.post('/stickers/update', body)).data
  }

  static async delete(id: number) {
    return (await $http.post('/stickers/delete', { id })).data
  }
}

export default StickersAPI
